import { FormDialogTemplate } from "../../../../../shared/form-dialog/form-dialog.template";
import { Subject, BehaviorSubject } from "rxjs";
import { FormBuilder, Validators } from "@angular/forms";
import { Injector } from "@angular/core";
import { FilterableService } from "../../../../mesc/filterable-service";
import { BaseService } from "../../../../mesc/mesc.service";
import { RequestDetailService } from "../detail.service";

export class AssignPLFormDialogTemplate extends FormDialogTemplate {
    private readonly dialogTitle: Subject<string> = new BehaviorSubject<string>('Assign Designer');
    private readonly formBuilder: FormBuilder;
    private readonly baseService: BaseService;
    private readonly userService: FilterableService = new FilterableService();
    private readonly detailService: RequestDetailService;

    constructor(private readonly injector: Injector) {
        super();
        this.formBuilder = injector.get(FormBuilder);
        this.baseService = injector.get(BaseService);
        this.detailService = injector.get(RequestDetailService);
        this.editForm = this.formBuilder.group({
            WFTaskId: [],
            Id: ['', Validators.required],
            Name: [],
            Email: [],
        });

        this.initilize(this.dialogTitle, this.editForm, this.userFormTabs);
    }

    userChange = (dataItem) => {
        const user = this.userService.value.find(u => u.Id === dataItem);
        if (user) {
            this.editForm.get('Name').setValue(user.cn);
            this.editForm.get('Email').setValue(user.Email);
        }
    }

    refreshUsers(role: string) {
        const module = this.detailService.module;
        this.baseService.read(`common/User/GetUsersByRoleCode/${module.Id}/${role.toUpperCase()}`)
            .then(x => this.userService.next(this.detailService.mapUsers(x)));
    }

    userFormControls: any[] = [{
        type: "combobox",
        title: "Designers",
        name: "Id",
        textField: "cn",
        valueField: "Id",
        service: this.userService,
        onChange: this.userChange,
        stretch: true
    },];

    userFormTabs = [
        {
            title: "Users",
            selected: true,
            formControls: this.userFormControls
        },
    ]

}
